import { api } from '../../config/ApiConfig';

export const Campaign = {
  load: (slug) => api.get(`/v1/campaigns/${slug}`)
}